<template><section><h3>插件介绍</h3>
<p>Tooltip， 提示框。</p>
<h3>attrs</h3>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>String | Function</td>
<td><code v-pre>null</code></td>
<td>标题</td>
</tr>
<tr>
<td>formatter</td>
<td>Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>除标题外，其他文本格式化函数</td>
</tr>
</tbody>
</table>
<h3>style</h3>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
tooltip.style(<span class="hljs-string">'text'</span>, { <span class="hljs-attr">color</span>: <span class="hljs-string">'#fff'</span> }
</code></pre>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>文本</td>
<td>html 文本样式</td>
</tr>
<tr>
<td>point</td>
<td>html 容器</td>
<td>html 容器样式</td>
</tr>
<tr>
<td>text</td>
<td>文本</td>
<td>html 文本样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>